import { render } from "./DbsHowToUseLinkButton.vue?vue&type=template&id=731918ec"
import script from "./DbsHowToUseLinkButton.vue?vue&type=script&lang=js"
export * from "./DbsHowToUseLinkButton.vue?vue&type=script&lang=js"
script.render = render

export default script